import React, { Fragment } from "react";

const Navigation = ({ links = [], contentLink = null, level = 1 }) => {
  let menuRef = React.createRef();
  function toggleMenu() {
    menuRef.current.classList.toggle("navbar__menu--show");
  }
  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const selectedClass =
    contentLink && contentLink.isSelected ? "navbar__link--selected" : "";
  const hasChildrenClass = links.length > 0 ? "has-children" : null;
  const hasNameOrChildren = (link) =>
    link.name || (link.links || []).length > 0;

  return (
    <Fragment>
      {!contentLink ? (
        <a
          className="navbar__link--block navbar__icon--menu navbar__icon"
          onClick={toggleMenu}
        >
          <svg className="icon">
            <use xlinkHref="/ui/images/JobMeal/icons/icons.svg#mobile--menu"></use>
          </svg>
        </a>
      ) : (
        <Fragment>
          <a
            className={`navbar__link ${selectedClass} ${hasChildrenClass || ""
              } ${additionClass || ""}`}
            href={contentLink.url || "#"}
            dangerouslySetInnerHTML={{ __html: contentLink.name }}
          ></a>
          {links.length > 0 && (
            <i
              className="navbar__icon--caret-right navbar__icon navbar__icon--open"
              onClick={toggleMenu}
            >
              <svg className="icon">
                <use xlinkHref="/ui/images/JobMeal/icons/icons.svg#chevron--down"></use>
              </svg>
            </i>
          )}
        </Fragment>
      )}

      {links.length > 0 && (
        <ul
          className={`navbar__menu navbar__menu--level-${level}`}
          ref={menuRef}
        >
          <div className="navbar__menu-header">
            {!contentLink ? (
              <Fragment>
                {/* <i
                className="navbar__icon navbar__icon--close"
                onClick={toggleMenu}
              >
                <svg className="icon">
                  <use xlinkHref={`${Icons}#close`} />
                </svg>
              </i> */}
              </Fragment>
            ) : (
              <Fragment>
                <i
                  className="navbar__icon--caret-left navbar__icon navbar__icon--back"
                  onClick={toggleMenu}
                >
                  <svg className="icon">
                    <use xlinkHref="/ui/images/JobMeal/icons/icons.svg#chevron--down"></use>
                  </svg>
                </i>
                <span
                  className="navbar__title"
                  onClick={toggleMenu}
                  dangerouslySetInnerHTML={{ __html: contentLink.name }}
                ></span>
              </Fragment>
            )}
          </div>
          {links.length > 0 &&
            links.map(
              (link, i) =>
                hasNameOrChildren(link) && (
                  <li className="navbar__item" key={link.url}>
                    <Navigation
                      links={link.links}
                      contentLink={link}
                      level={level + 1}
                    />
                  </li>
                )
            )}
        </ul>
      )}
    </Fragment>
  );
};

export default Navigation;
